import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=f30ce21e&scoped=true&"
import script from "./FaqEdit.vue?vue&type=script&lang=js&"
export * from "./FaqEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30ce21e",
  null
  
)

export default component.exports